import { AudioMessagePost } from '../AudioMessagePost/AudioMessagePost'

interface PostWithAudioProps {
    url: string
    updateSelectedPost: () => void
}

export const PostAudio = ({ url, updateSelectedPost }: PostWithAudioProps) => {
    return (
        <div
            className={'post__files__file post__files__file--sound'}
            onClick={updateSelectedPost}
        >
            <div className='post-sound-container'>
                <AudioMessagePost mediaUrl={url} />
            </div>
        </div>
    )
}
